module.exports = __webpack_public_path__ + "img/C1.b2ca18b1.jpg";